import React, { useEffect, useRef } from "react";

/**
 * ModalOptions — solo el dropdown, el padre controla cuando se abre/cierra.
 *
 * Props:
 *   options  — [{ label: string, onClick: fn, icon?: ReactNode }]
 *   onClose  — fn() — el padre lo usa para cerrar (setOpenOptionsFolio(null))
 */
export const ModalOptions = ({ options = [], onClose }) => {
    const ref = useRef(null);

    // Cerrar al click fuera
    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                onClose?.();
            }
        };
        // Delay para que el click que abrió no lo cierre inmediatamente
        const timer = setTimeout(() => {
            document.addEventListener("click", handler);  // ← "click" no "mousedown"
        }, 0);
        return () => {
            clearTimeout(timer);
            document.removeEventListener("click", handler);
        };
    }, [onClose]);

    // Cerrar con Escape
    useEffect(() => {
        const handler = (e) => { if (e.key === "Escape") onClose?.(); };
        document.addEventListener("keydown", handler);
        return () => document.removeEventListener("keydown", handler);
    }, [onClose]);

    return (
        <div ref={ref} className="pa-list-popover">
            {options.map((opt, i) => (
                <div
                    key={i}
                    className="pa-list-popover__option"
                    onClick={() => { opt.onClick?.(); onClose?.(); }}
                >
                    {opt.icon && (
                        <span className="pa-list-popover__icon">{opt.icon}</span>
                    )}
                    {opt.label}
                </div>
            ))}
        </div>
    );
};

export default ModalOptions;
